import { DataTableDefinition } from "@/v2/types/Datatable";
import { createColumnHelper, flexRender } from "@tanstack/react-table";
import { buildColumns } from "./buildColumns";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Eye, Pencil } from "lucide-react";
import { generateFilterColumn } from "../../filter";
import AccessControl from "../../rbac/AccessControl";
import { Payslip } from "@/v2/types";
import PayslipDeleteButton from "../../ui/button/delete/Payslip";
import PrintArEmployeePayslipPDF from "../../pages/payslip/ar-employee/Print";

type T = Payslip;

const columnHelper = createColumnHelper<T>();

const PayslipColumnDefintion: DataTableDefinition<T>[] = [
    {
        id: "sl",
        headingText: "Sl No",
        headingCellType: "small-cell",
        cellType: "text-center",
    },
    {
        id: "employee.full_name",
        headingText: "Employee Name",
    },
    {
        id: "net_amount",
        headingText: "Net Amount",
        headingCellType: "text-center",
        cellType: "money",
    },
    {
        id: "total_ot_hours",
        headingText: "Total Overtime Hours",
        headingCellType: "text-center",
        cellType: "money",
    },
    {
        id: "absent_deduction",
        headingText: "Absent Deduction",
        headingCellType: "text-center",
        cellType: "money",
    },
    {
        id: "actions",
        headingText: "Actions",
        headingCellType: "text-center",
        cell: ({ row }) =>
            flexRender(
                <div className="flex justify-center gap-2">
                    <Link to={`/payslips/ar-employee/${row.id}`}>
                        <Button variant={"outline"} size={"sm"}>
                            <Eye className="size-4" />
                        </Button>
                    </Link>
                    <PrintArEmployeePayslipPDF payslipId={row.id} />

                    <AccessControl
                        module="PAYSLIP_MANAGEMENT"
                        requestedAccess={"PUT"}
                    >
                        <Link to={`/payslips/ar-employee/edit/${row.id}`}>
                            <Button variant={"outline"} size={"sm"}>
                                <Pencil className="size-4" />
                            </Button>
                        </Link>
                    </AccessControl>

                    <AccessControl
                        module="PAYSLIP_MANAGEMENT"
                        requestedAccess={"DELETE"}
                    >
                        <PayslipDeleteButton id={row.id} />
                    </AccessControl>
                </div>,
                {},
            ),
    },
];

const PayslipColumn = buildColumns<T>(columnHelper, PayslipColumnDefintion);

const ArEmployeePayslipFilterColumn = generateFilterColumn<T>(
    PayslipColumnDefintion,
    {
        removeIds: [],
        renameMap: {},
    },
);

export {
    PayslipColumn as ArEmployeePayslipColumn,
    ArEmployeePayslipFilterColumn,
};
